export const StepsData = [
    {
        title: "Want to get rid off your plastic waste?",
        desc: "Visit our website and give the information of the type of waste, your details etc.",
        imgURL: "./Components/Homepage/Images/Working-step-1.jpg"
    },
    {
        title: "Place Order",
        desc: "Place order from the comfort of your home",
        imgURL: "./Components/Homepage/Images/Working-step-1.jpg"
    },
    {
        title: "Order Confirmation",
        desc: "Your Order is confirmed by a collector near you.",
        imgURL: "./Components/Homepage/Images/Working-step-1.jpg"
    },
    {
        title: "Collection",
        desc: "Collector collects the waste from your doorstep",
        imgURL: "./Components/Homepage/Images/Working-step-1.jpg"
    },
    {
        title: "Green Earth",
        desc: "By using our platform you help in managing the waste to a large extend and thus contribute in reducing the waste accumulation",
        imgURL: "./Components/Homepage/Images/Working-step-1.jpg"
    }
]

export const FeaturesData = [
    {
        id: "0",
        title: "Hassle free order placing",
        desc: "Place your order easily on our website with just a few steps."
    },
    {
        id: "1",
        title: "Doorstep Collection",
        desc: "Collectors will collect the waste from your doorstep."
    },
    {
        id: "2",
        title: "Online Payment",
        desc: "Perform Online Transactions by using our secure payment gateway."
        // },
        // {
        //     id: "3",
        //     title: "Login and Sign Up",
        //     desc: "Sign up using a login credentials",
        // 
        // },
        // {
        //     id: "4",
        //     title: "Login and Sign Up",
        //     desc: "Sign up using a login credentials",
        // 
    }
]

export const WhyRecycleData = [
    {
        title: "Saves Resources",
        desc: "To produce 1L plastic 3L of water and 1/4th L of crude oil is used. 1000 kilos of recycled paper can prevent the cutting of 18 trees. Recycling reduces water pollution by 34% and air pollution by 74%. 20% of the world's total oil consumption by about 2050.",
        videoURL: "https://www.youtube-nocookie.com/embed/F2pyi_SUhgQ"
    },
    {
        title: "Industry Revenue",
        desc: "Materials recovery in India will amount to approximately 3,5 billion U.S. Dollars by 2024",
        videoURL: "https://www.youtube-nocookie.com/embed/F2pyi_SUhgQ"
    },
    {
        title: "Improper Segregation/Collection",
        desc: "More than 8.3B tonnes of plastic have been created since the early 1950s. About 60% ended up in either a landfill or the natural environment.",
        videoURL: "https://www.youtube-nocookie.com/embed/F2pyi_SUhgQ"
    },
    {
        title: "More Focused Processing",
        desc: "More than three-fourth of solid waste management budget is allotted to collection and transportation, leaving leaves very little for processing or resource recovery and disposal. So making the process of collection and segregation easy will ensure more prioritized focus on processing.",
        videoURL: "https://www.youtube-nocookie.com/embed/F2pyi_SUhgQ"
    },
    {
        title: "Provides Employment",
        desc: "Some big cities of India could also provide employment opportunities to about 500,000 rag-pickers.",
        videoURL: "https://www.youtube-nocookie.com/embed/F2pyi_SUhgQ"
    }
]

export const FAQs = [
    {
        question: "Why your Service ?",
        answer: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
        id: 1
    },
    {
        question: "Why your Service ?",
        answer: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
        id: 2
    },
    {
        question: "Why your Service ?",
        answer: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
        id: 3
    },
    {
        question: "Why your Service ?",
        answer: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
        id: 4
    },
    {
        question: "Why your Service ?",
        answer: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
        id: 5
    },
    {
        question: "Why your Service ?",
        answer: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
        id: 6
    },
    {
        question: "Why your Service ?",
        answer: "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
        id: 7
    }
]

export const FooterData = {
    aboutProject: "To encourage and develop an efficient and eco-friendly recycling model, for which we're looking to connect the customers(donors) to the recyclers along with the worthwhile exchange of money between them.",
    phoneNumber: "7030405299",
    email: "support@pbl.com",
    links: {
        instagram: "https://www.instagram.com/pict.pune/",
        github: "https://github.com/pblProject2022",
        linkedin: "https://www.linkedin.com/in/pblProject2022",
        collegeLocation: "https://www.google.com/maps/dir//pict/@18.4575292,73.7807931,12z/data=!3m1!4b1!4m9!4m8!1m1!4e2!1m5!1m1!1s0x3bc2eac85230ba47:0x871eddd0a8a0a108!2m2!1d73.8508336!2d18.4575421"
    }
}